// src/components/GTMPageView.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function GTMPageView() {
  const location = useLocation();

  useEffect(() => {
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
}
